<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("shipping") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

               
                <div class="col-lg-6 col-5 text-right">
                    <router-link to="/backoffice/packings/shipping/coupon/v2">
                        <base-button size="md" type="neutral" class="ml-2">
                            ส่งและตรวจสอบการส่งสินค้า
                        </base-button>
                    </router-link>
                    <router-link to="/backoffice/packings/shipping/checking">
                        <base-button size="md" type="neutral" class="ml-2">
                            ตรวจสอบการส่งสินค้า
                        </base-button>
                    </router-link>
                    <router-link to="/backoffice/packings">
                        <base-button size="md" type="neutral" class="ml-2">{{
                            $t("back")
                        }}</base-button>
                    </router-link>
                </div>
            </div>
        </base-header>

        <div class="row">
            <div class="container-fluid mt--6 col-lg-4">
                <div>
                    <card
                        header-classes="bg-transparent"
                        footer-classes="bg-transparent"
                        body-classes="px-lg-4 py-lg-4"
                        class=" border-0  mb-4"
                    >
                        <template slot="header">
                            <!-- Select storage_id , shipping -->
                            <div class="form-group row">
                                <!-- <div class="col-md-6">
                                    <base-input
                                        :label="$t('wms.menu.inventory')"
                                    >
                                        <el-select
                                            v-model="params.storage_id"
                                            :label="$t('wms.menu.inventory')"
                                            :disabled="lock"
                                        >
                                            <el-option
                                                v-for="option in StorageTable"
                                                :key="option.ID"
                                                :label="option.Name"
                                                :value="option.ID"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div> -->

                                <!-- <div class="col-md-6">
									<base-input :label="$t('shipping_provider')" >
										<el-select v-model=" params.shipping_provider_id " :label="$t('shipping_provider')"  :disabled="lock">
											<el-option v-for="option in ShippingProviderTable" :key="option.id" :label="option.name" :value="option.id" > </el-option>
										</el-select>
									</base-input>
								</div> -->

                                <div class="col-md-6">
                                    <base-input :label="$t('platform')">
                                        <el-select
                                            v-model="params.platform_id"
                                            :label="$t('platform')"
                                            :disabled="lock"
                                        >
                                            <el-option
                                                v-for="option in PlatformTable"
                                                :key="option.id"
                                                :label="option.name"
                                                :value="option.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>

                                <div class="col-md-6">
                                    <base-input label="ประเภทบาร์โค้ด">
                                        <el-select
                                            v-model="params.barcode_type"
                                            label="Barcode Type"
                                            :disabled="lock"
                                        >
                                            <el-option
                                                v-for="option in BarcodeTypeTable"
                                                :key="option.id"
                                                :label="option.name"
                                                :value="option.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>

                                <!-- Lock -->
                                <div class="col-md-3 py-4">
                                    <base-button
                                        @click="handleUnLock"
                                        v-if="lock"
                                        >UnLock</base-button
                                    >

                                    <!-- Unlock -->
                                    <base-button
                                        @click="handleLock"
                                        v-if="!lock"
                                        >Lock</base-button
                                    >
                                </div>
                            </div>
                        </template>

                        <div class="row" v-if="lock">
                            <div class="col-md-12">
                                <base-input
                                    :placeholder="$t('scanbarcode')"
                                    v-model="barcode"
                                    class="form-control-alternative"
                                    prepend-icon="ni ni-zoom-split-in"
                                    v-on:keyup.enter="handleBarcode"
                                ></base-input>
                            </div>
                            <div class="col-md-12" v-if="isWait">
                                <span>
                                    <i class="fas fa-spinner fa-spin"></i>
                                    กำลังประมวลผล...</span
                                >
                            </div>

                            <div class="col md-12 mt-3" v-if="params.barcode_type == 1">
                                Order : {{ params.id }}
                                <div v-for="c in coupons" :key="c">
                                    <div>คูปอง - {{ c}} </div>
                                </div>
                            </div>

                            <div class="col md-12 mt-3" v-if="params.barcode_type == 2">
                                Tracking : {{ first_barcode }}
                                <div v-for="c in coupons" :key="c">
                                    <div>คูปอง - {{ c}} </div>
                                </div>
                            </div>


                        </div>

                        <!-- Show Order ID -->
                    </card>
                </div>
            </div>

            <div class="container-fluid mt--6 col-lg-8" v-if="false">
                <div>
                    <!-- card right -->
                    <card
                        class="no-border-card"
                        body-classes="px-0 pb-1"
                        footer-classes="pb-2"
                    >
                        <template slot="header">
                            <div class="row">
                                <label
                                    class="col-md-12 col-form-label form-control-label"
                                >
                                    <h3
                                        class="mb-0"
                                        v-if="params.id == '' || params.id == 0"
                                    >
                                        {{ $t("order_information") }}
                                    </h3>
                                    <h3 class="mb-0" v-else>
                                        {{ $t("order_information") }} :
                                        {{ this.params.id }}

										<template v-if="params.tracking_number != ''">
											- Tracking Number : {{ this.params.tracking_number }}
										</template>
                                    </h3>
                                </label>
                            </div>
                        </template>
                        <!-- Selected Product -->
                        <div
                            v-if="allScanned(order_items)"
                            class="packing-all-scanned text-success font-weight-bold"
                            data-testid="packing-all-scanned"
                        >
                            <i class="fa fa-check-circle"></i>
                            {{ $t("packing_all_scanned") }}
                        </div>
                        <div class="row">
                            <div
                                class="col-lg-3"
                                v-for="o in order_items"
                                :key="o.id"
                            >
                                <div class="card" :class="scannedCardClass(o)">
                                    <img
                                        class="card-img-top"
                                        :src="GetProductImage(o.wms_product_id)"
                                        style="max-height:150px; width:150px;margin-left: auto; margin-right: auto;"
                                    />
                                    <div class="card-body">
                                        <h3>
                                            <span
                                                class="text-green"
                                                v-if="o.pickup_need == null"
                                            >
                                                {{ o.wms_product_name }}
                                            </span>
                                            <span v-else>
                                                {{ o.wms_product_name }}
                                            </span>
                                            (
                                            <span
                                                class="text-green"
                                                v-if="o.pickup_need == null"
                                                >{{
                                                    o.pickup_need == null
                                                        ? o.pickup_quantity
                                                        : o.pickup_quantity -
                                                          o.pickup_need
                                                }}
                                                / {{ o.pickup_quantity }}
                                            </span>
                                            <span v-else
                                                >{{
                                                    o.pickup_need == null
                                                        ? o.pickup_quantity
                                                        : o.pickup_quantity -
                                                          o.pickup_need
                                                }}
                                                / {{ o.pickup_quantity }}
                                            </span>
                                            )
                                        </h3>

                                        <div
                                            class="col-md-12 text-green"
                                            v-if="o.pickup_need == null"
                                        >
                                            {{ o.barcode }}
                                        </div>
                                        <div class="col-md-12" v-else>
                                            {{ o.barcode }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>

        <!--  Modal -->
        <modal :show.sync="showModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                Loading...
            </form>

            <template slot="footer"> </template>
        </modal>

		<modal :show.sync="showSyncModal" modal-classes="modal-secondary">
			<validation-observer ref="formValidator" >

            <form class="new-event--form" @submit.prevent="saveEvent">
                <base-input :label="$t('platform_order_id')" :name="$t('platform_order_id')" v-model="platform_order_id" rules="required"> </base-input>
            </form>
			</validation-observer>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handlePlatformSync()"
                >
                    Sync
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showSyncModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import FileInput from "@/components/Inputs/FileInput";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { CouponService } from "../../resource";
import { allScanned, scannedCardClass } from "@/utils/packingScan";

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        FileInput,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            StorageTableOrg: "WmsStorage/getData",
            // #416 ruling: packing / return rooms verify order contents (barcode + image); old
            // orders with a disabled product must still pack, so this reads the active=all list.
            ProductTable: "WmsProduct/getDataAll",
            PlatformTable: "Order/getPlatformTable"
        }),

        BarcodeTypeTable() {
            return [
                { id: 1, name: "Order" },
                { id: 2, name: "Tracking" },
            ];
        },

        StorageTable() {
            return this.StorageTableOrg.filter(item => {
                return item.ID != 1;
            });
        }
    },
    watch: {
        "params.platform_id": {
            handler: function(val) {
                switch (val) {
                    case 1: // self
                        this.params.barcode_type = 1;
                        break;
                    case 2: // Tiktoke
                        this.params.barcode_type = 2;
                    case 3: // shopee
                        this.params.barcode_type = 2;
                    case 4: // lazada
                        this.params.barcode_type = 2;
                    case 5: // line
                        this.params.barcode_type = 2;
                        break;
                }
                console.log("platform_id", val);
            },
            deep: true
        },
    },
    data() {
        return {
            isLoading: false,
            showModal: false,
            lock: false,
            isWait: false,

            state: 0,
            barcode: "",
            first_barcode: "",
            pickup_items: [], // สินค้าที่หยิบใส่กล่องแล้ว
            order_items: [], // สินค้าที่เลือกจาก Order
            coupons: [],

            params: {
                id: 7,
                shipping_provider_id: 0,
                tracking_number: "",
                storage_id: "",
                barcode: "",
                platform_id: 1,
                barcode_type: 1
            },

			showSyncModal: false,
			platform_order_id:"",

            propsToSearch: []
        };
    },
    async mounted() {
        this.listStorage();
        this.listProduct({ active: "all" });
        this.clearParam();

		try {
            let resp = await this.getProfile()
            let user = resp.data.Datum
            console.log(user)
            this.params.storage_id = user.wms_storage_id

            if (this.params.storage_id == 0) {
                swal.fire({
                    title: "ผู้ใช้งานนี้ยังไม่ได้ตั้งค่าคลังสินค้า",
                    text: "กรุณาติดต่อผู้ดูแลระบบเพื่อตั้งค่าคลังสินค้า",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false,
                }).then(()=>{
                    this.$router.go(-1)
                })

            }
        } catch (err){
            console.log(err)
            swal.fire({
                title: "ตรวจสอบข้อมูลคลังสินค้าผิดพลาด",
                text: "กรุณาติดต่อผู้ดูแลระบบเพื่อตั้งค่าคลังสินค้า",
                icon: "error",
                confirmButtonClass: "btn btn-danger btn-fill",
                buttonsStyling: false,
            }).then(()=>{
                this.$router.go(-1)
            })
        }
        },
    methods: {
        allScanned,
        scannedCardClass,
        ...mapActions({
            listSaleChannel: "SaleChannel/listData",
            listStorage: "WmsStorage/listData",
            listProduct: "WmsProduct/listData",
            addItem: "Packing/addPickupItem",
            removeItem: "Packing/removePickupItem",
            closeOrder: "Packing/closeShippingOrder",
			syncPlatformOrder : "Order/syncPlatformOrder",
			getProfile : "Auth/getProfile",
			shippingCreateAndClose: "Packing/shippingCreateAndCloseWithCoupon"
        }),
        async handleBarcode() {
            console.log("handleBarcode", this.barcode);
            console.log("state", this.state);

            this.params.barcode = this.barcode;
            this.barcode = "";


            if (this.isWait) {
                console.log("isLoading... , cancel this barcode");
                return;
            }

            switch(this.state){
                case 0:
                // ================================  Wait  order id or tracking  ================================
                    this.first_barcode = this.params.barcode;

                    console.log("state:0 , platform_id", this.params.platform_id);
                    if (this.params.barcode_type == 1) {
                        // MDF must be order
                        let isOrder = this.params.barcode.startsWith("MDF");
                        let orderId = this.params.barcode.replace("MDF", "");

                        try {
                            orderId = parseInt(orderId);
                        } catch (error) {
                            console.log("error", error);
                            this.showModal = false;
                            swal.fire({
                                title: error,
                                text: "",
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                            return;
                        }
                        console.log("isOrder", isOrder);
                        if (!isOrder) {
                            this.showModal = false;
                            swal.fire({
                                title: "Barcode ไม่ถูกต้อง",
                                text: "Barcode ต้องเป็นรหัส Order เท่านั้น",
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                            return;
                        }

                        this.params.id = orderId;
                    } else {

                    }
                    console.log("params", this.params);
                    this.state = 1
                    break;

                    case 1:
                    //================================ Get Coupon Or Close Order ================================

                    if (this.params.barcode == "CLOSEORDERMDF")
					{
                        // check coupon is exist
                        if (this.coupons.length == 0) {
                            swal.fire({
                                title: "กรุณาเพิ่มคูปอง",
                                text: "",
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                            return;
                        }

                        // alert("Preocess Order")
                        this.processOrder();
                        return;

					}


                    // params.barcode is url
                    if (this.params.barcode.startsWith("http")) {
                        // check coupon is exist

                        // example of url is https://event.madamefin.com/register?number=900099&code=mrqKsiEp4M   , i need to extrack queryparams (number)
                        let url = new URL(this.params.barcode);
                        let coupon_number = url.searchParams.get("number");
                        let coupon_code = url.searchParams.get("code");

                         // Remove non-numeric characters from coupon_number (e.g. prefix)
                        if (coupon_number) {
                            coupon_number = coupon_number.replace(/\D/g, '');
                        }

                        console.log("coupon_number", coupon_number);
                        console.log("coupon_code", coupon_code);

                        if (coupon_number == "" || coupon_code =="") {
                            swal.fire({
                                title: "คูปองไม่ถูกต้อง",
                                text: "Nmber=" + coupon_number + " Code=" + coupon_code,
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                            return;
                        }

                        // check coupon is exist
                        let coupon = this.coupons.find(x => x == coupon_number);
                        if (coupon) {
                            swal.fire({
                                title: "คูปองนี้ถูกเพิ่มแล้ว",
                                text: "Nmber=" + coupon_number + " Code=" + coupon_code,
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                            return;
                        }

                        // add coupon number to coupons  with ["00","11","22"]
                        try {
                            coupon_number = parseInt(coupon_number);
                            this.coupons.push(coupon_number);
                        } catch (error) {
                            console.log("error", error);
                            this.showModal = false;
                            swal.fire({
                                title: error,
                                text: "เพิ่มคูปองไม่สำเร็จ",
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                            return;
                        }
                        return

                    }


                    swal.fire({
                        title: "คูปองไม่ถูกต้อง",
                        text: "Barcode  ต้องเป็นคูปองหรือปิด Order เท่านั้น",
                        icon: "error",
                        confirmButtonClass: "btn btn-danger btn-fill",
                        buttonsStyling: false
                    });

                    break;

            }
            // Fetch Order ID





        },

        async processOrder() {
            this.isWait = true;
            this.showModal = true;
            try {
                let params = {
                    id: this.params.barcode_type == 1 ? this.params.id : 0,
                    storage_id: this.params.storage_id,
                    coupon_numbers : this.coupons,
                    barcode: this.params.barcode_type == 2 ?this.first_barcode: "",
                    platform_id : this.params.platform_id
                }

                console.log ("params", params)
                // this.isWait = false;
				// this.showModal = false;
				let resp = await this.shippingCreateAndClose(params)

				// Success
				this.showModal = false;
                this.isWait = false;
				this.clearParam();
				swal.fire({
					title: "สร้างรายการส่งสินค้าเรียบร้อย",
					text: "",
					icon: "success",
					confirmButtonClass: "btn btn-success btn-fill",
					buttonsStyling: false
				});
			}
			catch (err) {
				console.log(err)
                this.isWait = false;
				this.showModal = false;
				swal.fire({
					title: this.$t(err.response.data.Msg),
					text: err.response.data.Cause,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}
        },

        handleLock() {
            //  check storage sleected
            if (this.params.storage_id == "") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกคลังสินค้า",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

            this.lock = true;
            this.clearParam();
        },
        handleUnLock() {
            this.lock = false;
            this.clearParam();
        },
        clearParam() {
            this.order_items = [];
            this.pickup_items = [];
            this.params.id = "";
            this.params.tracking_number = "";
            this.params.barcode = "";
            this.barcode = "";
            this.coupons = [];
            this.first_barcode = "";
            this.state = 0;
        },
        GetProductImage(id) {
            // find product table
            let product = this.ProductTable.find(x => x.ID == id);
            if (product) {
                return (
                    process.env.VUE_APP_API_BASE_URL +
                    "/files/wms_products/" +
                    product.Image
                );
            } else {
                return "";
            }
        }
    }
};
</script>

<style scoped>
.el-table td {
    padding: 0 !important;
}
/* Packing room: a scanned product card gets a green frame; the green
   "all scanned" line sits above the cards (docs/specs/2026-10-06-packing-
   scanned-highlight-design.md P1/P3). Scoped, not in argon.scss: the shared
   theme is frozen by tests/unit/buttonDangerInk.spec.js. */
.packing-item--scanned {
    border: 2px solid #2dce89;
    background: rgba(45, 206, 137, .08);
}
.packing-all-scanned {
    font-size: 1.1rem;
    margin-bottom: .75rem;
    /* P3a: stand out by the band, not the text colour (text-success stays). */
    background: rgba(45, 206, 137, 0.15);
    border-left: 4px solid #2dce89;
    padding: 0.5rem 0.75rem;
    border-radius: 0.25rem;
}
</style>
